import { css, keyframes } from 'styled-components';
import ndsTokens from 'nicollet-tokens';

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;
const block = css`
  display: block;
  margin: 0 auto;
`;
const selfCentering = css`
  ${block};
  top: 50%;
  transform: translateY(-50%);
`;
const inlineBlock = css`
  display: inline-block;
  vertical-align: middle;
`;
const PX_SIZES = {
  xsmall: '16px',
  small: '28px',
  medium: '42px',
  large: '56px'
};
const layoutStyles = {
  block,
  inlineBlock,
  selfCentering
};

const pxSize = size => PX_SIZES[size !== null && size !== void 0 ? size : ''] || PX_SIZES.medium;

const layoutStyle = layout => layoutStyles[layout !== null && layout !== void 0 ? layout : ''] || layoutStyles.block;

var styles = css`
  font-size: ${ndsTokens.font.size.body.medium};
  line-height: 1;
  position: relative;
  width: ${props => pxSize(props.size)};
  height: ${props => pxSize(props.size)};

  text-indent: initial;
  text-align: center;

  ${props => layoutStyle(props.layout)};

  svg {
    width: 100%;
    height: 100%;
    animation: ${spin} 550ms infinite linear;
    transform: translateZ(0);
  }
`;

export { styles as default };
